export const TAG_COLORS = [
  "#FBCB4A",
  "#3095AA",
  "#F89B38",
  "#3FBD7E",
  "#F51D3F",
  "#ABA2EC"
];
